import { render, staticRenderFns } from "./LinkRotator.vue?vue&type=template&id=2cf348aa&scoped=true"
import script from "./LinkRotator.vue?vue&type=script&lang=js"
export * from "./LinkRotator.vue?vue&type=script&lang=js"
import style0 from "./LinkRotator.vue?vue&type=style&index=0&id=2cf348aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf348aa",
  null
  
)

export default component.exports